import { ModalsProvider, NotificationsProvider, ThemeProvider } from '@inflearn/ds-react';
import { useLang } from '@inflearn/i18n-tools';
import type { ReactNode } from 'react';

import { NEXT_PUBLIC_CDN_URL } from '../../appConfig';
import { styleCache } from '../utils/emotionCache';

export function DsProvider({ children }: { children: ReactNode }) {
  const { lang } = useLang();

  return (
    <ThemeProvider cdnLink={NEXT_PUBLIC_CDN_URL || ''} emotionCache={styleCache} lang={lang}>
      <NotificationsProvider />
      <ModalsProvider>{children}</ModalsProvider>
    </ThemeProvider>
  );
}
